// extracted by mini-css-extract-plugin
export default {"bar":"promotion-page_bar__zGHYr","promotion":"promotion-page_promotion__yarbJ"};